import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
//import { loadingBarReducer } from "react-redux-loading-bar";

import {
  //mediasReducerByType,
  mediasReducer,
  wheretobillReducer,
  authReducer,
  visibleSearchLayerReducer,
  languageReducer,
  currentNavPageReducer,
  masonryReducer,
  sourcesTokensReducer,
  notificationsReducer,
  topicsReducer,
  mediaViewerReducer,
  articleViewerReducer,
  mailViewerReducer,
  pageViewerReducer,
  clientEboxViewerReducer,
  topicViewerReducer,
  commentReducer,
  articlesReducer,
  pelletsReducer,
  directoriesReducer,
  dashboardsReducer,
  surveyReducer,
  workflowReducer,
  usersReducer,
  webtoolsReducer,
  webtoolsFavoritesReducer,
  webtoolsCategoriesReducer,
  webtoolsFilterReducer,
  socialReducer,
  eventsReducer,
  notifsReducer,
  eboxReducer,
  galleryReducer,
  clientEboxReducer,
  flashMessageReducer,
  pdfViewerReducer,
  visibleAreasReducer,
  searchSelectReducer,
  publicPortalReducer,
  drawerIframeReducer,
  hubReducer,
  filterReducer,
  pagesReducer
} from "Reducers";

export const createReducer = () =>
  combineReducers({
    auth: authReducer,
    medias: mediasReducer,
    pages: pagesReducer,
    /*medias: combineReducers({
      all: mediasReducerByType("ALL"),
      image: mediasReducerByType("IMAGE"),
      video: mediasReducerByType("VIDEO"),
      pdf: mediasReducerByType("PDF"),
      ppt: mediasReducerByType("PPT"),
      hd: mediasReducerByType("HD")
    }),*/
    wheretobill: wheretobillReducer,
    params: combineReducers({
      lng: languageReducer,
      currentNavPage: currentNavPageReducer,
      masonry: masonryReducer,
      sourcesTokens: sourcesTokensReducer,
      notification: notificationsReducer,
      visibleSearchLayer: visibleSearchLayerReducer,
      publicPortal: publicPortalReducer,
      visibleAreas: visibleAreasReducer,
      searchSelectItems: searchSelectReducer,
      flashMessage: flashMessageReducer,
      drawerIframe: drawerIframeReducer
    }),
    filters: filterReducer,
    routing: routerReducer,
    //loadingBar: loadingBarReducer,
    topics: topicsReducer,
    mediaViewer: mediaViewerReducer,
    articleViewer: articleViewerReducer,
    mailViewer: mailViewerReducer,
    pageViewer: pageViewerReducer,
    clientEboxViewer: clientEboxViewerReducer,
    topicViewer: topicViewerReducer,
    comments: commentReducer,
    social: socialReducer,
    ebox: combineReducers({
      mails: eboxReducer,
      gallery: galleryReducer,
      client: clientEboxReducer
    }),
    events: eventsReducer,
    notifs: notifsReducer,
    articles: articlesReducer,
    pellets: pelletsReducer,
    directories: directoriesReducer,
    dashboards: dashboardsReducer,
    survey: surveyReducer,
    workflow: workflowReducer,
    users: usersReducer,
    webtools: combineReducers({
      list: webtoolsReducer,
      favorites: webtoolsFavoritesReducer,
      categories: webtoolsCategoriesReducer,
      filter: webtoolsFilterReducer
    }),
    pdfViewer: pdfViewerReducer,
    hub: hubReducer
  });



// WEBPACK FOOTER //
// ./src/store/createReducer.js